import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate'

const pinia = createPinia()
pinia.use(
  createPersistedState({
    key: (storeKey) => `ask-spinner-admin:${storeKey}`
  })
)

export default pinia
